/*
 * *
 *   ~  * Copyright (c) by INFODATA-GROUP. All rights reserved.
 *   ~  * No part of this publication may be reproduced, distributed,
 *   ~  * or transmitted in any form or by any means, including photocopying, recording,
 *   ~  * or other electronic or mechanical methods, without the prior written permission of the publisher,
 *   ~  * except in the case of brief quotations embodied in critical
 *   ~  * reviews and certain other noncommercial uses permitted by copyright law.
 *   ~  * AUTHOR : bs
 *   ~  * DATE : 07/05/2025 16:54
 *
 */

import {
  AuthorizationService,
  ExportService,
} from '@infodata-group/inf-commons';
import { environment } from '../environments/environment';
import {
  AoSharedDataService,
  devInterceptor,
  HttpStatusUnauthorizedInterceptor,
  MockInterceptor,
  VersionInterceptor,
} from '@monorepo-projects/alwayson-shared';
import {
  ApplicationConfig,
  importProvidersFrom,
  isDevMode,
  provideEnvironmentInitializer,
} from '@angular/core';
import { CustomPreloaderStrategy } from '@monorepo-projects/inf-commons-lib';
import { provideRouter, withPreloading } from '@angular/router';
import { initializerFactory } from './config/app-init.config';
import { appRoutes } from './app.routes';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptors,
  withInterceptorsFromDi,
  withXhr
} from '@angular/common/http';
import { devMockInterceptor } from './module/fleet/interceptor/dev-mock.interceptor';
import { bbxInterceptor } from './module/fleet/interceptor/bbx-interceptor';
import { BrowserModule } from '@angular/platform-browser';
import { DragDropModule } from '@angular/cdk/drag-drop';
import {
  commonsProviders,
  commonsProvidersFrom,
} from './config/commons.config';
import { storeProviders } from './config/store.config';
import { provideServiceWorker } from '@angular/service-worker';
import { CustomAuthorizationService } from './service/custom-authorization.service';
import { AoExportService } from './service/ao-export.service';
import { DataService } from './service/data.service';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';

registerLocaleData(localeFr);

const extraInterceptor = [];
if (!environment.production) {
  extraInterceptor.push(devInterceptor);
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideEnvironmentInitializer(initializerFactory),
    provideRouter(appRoutes, withPreloading(CustomPreloaderStrategy)),
    provideHttpClient(withXhr(), withInterceptors([devMockInterceptor, bbxInterceptor])),
    importProvidersFrom(
      BrowserModule,
      DragDropModule,
      ...commonsProvidersFrom,
      ...storeProviders,
    ),
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000',
    }),
    ...commonsProviders,
    { provide: AuthorizationService, useClass: CustomAuthorizationService },
    { provide: ExportService, useClass: AoExportService },
    { provide: HTTP_INTERCEPTORS, useClass: MockInterceptor, multi: true },
    { provide: CustomPreloaderStrategy, useClass: CustomPreloaderStrategy },
    { provide: AoSharedDataService, useClass: DataService },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpStatusUnauthorizedInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: VersionInterceptor,
      multi: true,
    },
    provideHttpClient(withXhr(), 
      withInterceptorsFromDi(),
      withInterceptors([...extraInterceptor]),
    ),
  ],
};
